import { version } from '../../package.json'

/**
 * This build's version string: sent as the `x-macrotide-version` header on every API request (docs/plan/api.md's
 * usage headers) and compared against `/config`'s `minVersion.web` to prompt a reload. Bumped in package.json like
 * the Android release's `versionName`.
 */
export const APP_VERSION: string = version

/** `x-macrotide-platform` is always this on the web (docs/plan/api.md). */
export const PLATFORM = 'web'
